var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('h1',{staticClass:"text-center"},[_vm._v("Deals iframe")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }